import React from 'react';
import { VictoryPie } from 'victory';
import { IChartCardLeftProps } from '.';

const BinaryLeft: React.FC<IChartCardLeftProps> = ({ helper }) => (
  <div style={{ height: 45, width: 45 }}>
    <VictoryPie
      data={helper.pieChart().data}
      colorScale={helper.pieChart().colorsBinary}
      padding={0}
      labels={[]}
      animate={{
        duration: 500,
        onLoad: { duration: 750 }
      }}
    />
  </div>
);

export default BinaryLeft;
